require('angular');

angular.module('app').service('ecommerce', function(){

    this.convertBasketItemsToGA4Ecommerce = function(basketItems) {
        var ordersToSend    = [];
        angular.forEach(basketItems, function(item, key) {
            //item.api_to_send_order.payment_type     = $scope.payment_type;
            //item.api_to_send_order.shopping_cart_id = shoppingCartId;
            //ordersToSend.push(item.api_to_send_order);
            var priceId = 'price_' + item.api_to_send_order.currency;
            priceId     = priceId.toLowerCase();

            ordersToSend.push({
                'item_id': item.service_id,
                'item_name' : item.service_name,
                'item_variant' : item.private_or_group,
                'item_category' : item.service_type,
                'item_category2' : item.people_quantity,
                'item_category3' : item.api_to_send_order.pick_up_type,
                'item_category4' : item.date,
                'item_category5' : item.language,
                'affiliation' : 'krakowdirect.com',
                'currency' : item.api_to_send_order.currency,
                'discount' : 0,
                'index' : parseInt(key)+1,
                'item_brand' : item.api_to_send_order.channel,
                'quantity' : 1,
                'price' : item[priceId]
            });
        });

        return ordersToSend;
    }

    this.purchase = function(cart, total, currency, shoppingCartId) {
        var ecomItems = this.convertBasketItemsToGA4Ecommerce(cart);
        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"purchase",
            ecommerce: {
                'transaction_id':   shoppingCartId,
                'value':            total,
                'tax':              0,
                'shipping':         0,
                'currency':         currency,
                'items':            ecomItems
            }
        });

    }

    this.addPaymentInfo = function(cart, total, currency,paymentType, coupon) {
        var ecomItems = this.convertBasketItemsToGA4Ecommerce(cart);
        ecomItems

        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"add_payment_info",
            ecommerce: {
                'currency':                 currency,
                'value':                    total,
                'coupon':                   coupon,
                'payment_type':             paymentType,
                'items':                    ecomItems,
            }
        });

    }

    this.convertOrderItemToGA4Ecommerce = function(order, currency) {
        var priceId         = 'price_' + currency;
        priceId             = priceId.toLowerCase();
        return {
            'item_id': order.service_id,
            'item_name': order.service_name,
            'affiliation': 'krakowdirect.com',
            'coupon' : 'DUMMY_COUPON',
            'currency': currency.toUpperCase(),
            'discount': 0,
            'index': 1,
            'item_brand': order.channel,
            'item_category': order.service_type,
            'item_category2': order.people_quantity,
            'item_category3': order.pick_up_type,
            'item_category4': order.date,
            'item_category5': order.language,
            'item_variant': order.private_or_group,
            'price': order[priceId],
            'quantity': 1
        };
    }

    this.addToCart = function(order, currency, coupon) {
        return;
        // To remove - legacy code!
        var ecomItem  = this.convertOrderItemToGA4Ecommerce(order, currency);
        if(!!coupon) ecomItem.coupon = coupon;
        var ecomItems = [];
        ecomItems.push(ecomItem);

        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"add_to_cart",
            ecommerce: {
                'currency':                 currency.toUpperCase(),
                'value':                    ecomItem.price,
                'items':                    ecomItems
            }
        });

    }

    this.beginCheckout = function(cart, total, currency, coupon) {
        var ecomItems = this.convertBasketItemsToGA4Ecommerce(cart);
        angular.forEach(ecomItems, function(item, key) {
            if(!!coupon) item.coupon = coupon;
        });
        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"begin_checkout",
            ecommerce: {
                'value':            total,
                'currency':         currency,
                'items':            ecomItems,
                'coupon':           coupon
            }
        });
    }

    this.removeFromCart = function(cart, total, currency, id) {
        var orders = [];
        angular.forEach(cart, function(item, key){
            if(item.id == id){
                orders.push(item);
            }
        });

        var ecomItems = this.convertBasketItemsToGA4Ecommerce(orders);

        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"remove_from_cart",
            ecommerce: {
                'value':            total,
                'currency':         currency,
                'items':            ecomItems
            }
        });
    }

    this.viewCart = function(cart, total, currency) {
        var ecomItems = this.convertBasketItemsToGA4Ecommerce(cart);

        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"view_cart",
            ecommerce: {
                'value':            total,
                'currency':         currency,
                'items':            ecomItems
            }
        });
    }

    this.convertPriceCheckerParamsToGA4Ecommerce = function(params, currency, serviceName, serviceType, price) {
        let priceId = currency == 'EUR' ? 'euro' : currency;
        priceId     = priceId.toLowerCase()+'Total';

        let date    = typeof params.date == 'object' ? params.date.toLocaleDateString('lt'): params.date;
        return {
            'item_id': params.service_id,
            'item_name': serviceName,
            'affiliation': 'krakowdirect.com',
            'coupon' : 'DUMMY_COUPON',
            'currency': currency.toUpperCase(),
            'discount': 0,
            'index': 1,
            'item_brand': params.channel,
            'item_variant': params.private_or_group,
            'item_category': serviceType,
            'item_category2': params.people_quantity,
            'item_category3': params.pick_up_type,
            'item_category4': date,
            'item_category5': params.lang,
            'price': price[priceId],
            'quantity': 1
        };
    }

    this.viewItem = function(params, currency, serviceName, serviceType, price, coupon) {
        return;
        // To remove - legacy code!
        var ecomItem  = this.convertPriceCheckerParamsToGA4Ecommerce(params, currency, serviceName, serviceType, price, coupon);
        if(!!coupon) ecomItem.coupon = coupon;
        var ecomItems = [];
        ecomItems.push(ecomItem);

        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"view_item",
            ecommerce: {
                'currency':                 currency.toUpperCase(),
                'value':                    ecomItem.price,
                'items':                    ecomItems
            }
        });
    }

    this.generateLead = function(price, currency){
        dataLayer.push({
            ecommerce:null
        });
        dataLayer.push({
            event:"generate_lead",
            ecommerce: {
                'currency':                 currency,
                'value':                    price
            }
        });

    }
});